import { checkForVaiControllerTransactionError } from 'errors';
import type { TransactionReceipt } from 'web3-core';

import { VaiController, UmiVault } from 'types/contracts';

export interface IsetOrganizationInput {
  umiControllerContract: UmiVault;
  fromAccountAddress: string;
  amountWei: string;
}

export type IsetOrganizationOutput = TransactionReceipt;

const setOrganization = async ({
                          umiControllerContract,
  fromAccountAddress,
  amountWei,
}: IsetOrganizationInput): Promise<IsetOrganizationOutput> => {
  const resp = await umiControllerContract.methods
      .setOrganization(amountWei)
    .send({ from: fromAccountAddress });
  return checkForVaiControllerTransactionError(resp);
};

export default setOrganization;
